export const version = '2.46.1';
//# sourceMappingURL=version.js.map